<template>
  <div class="flex flex-col text-center h-12">
    <FileUpload
      mode="basic"
      :accept="props.accept"
      :maxFileSize="propStore.maxFileSize"
      customUpload
      @uploader="onUpload"
      :auto="true"
      :chooseLabel="label"
      class="h-10"
      :class="size"
    />
    <small v-if="file">{{ file.name }}</small>
  </div>
</template>

<script setup lang="ts">
import { usePropsStore } from "@/stores/props";

const file = defineModel<File | null>("file", { required: true });
const propStore = usePropsStore();

interface Props {
  size?: string;
  accept?: string;
  label?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: "w-96",
  accept: ".csv,.xlsx",
  label: "Import File",
});

const onUpload = (event: any): void => {
  file.value = event.files[0];
  success("Success", "File Uploaded");
};
</script>
